import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as taxbillApi from '../../lib/api/taxbill';
import { recentOneYearStr, recentOneYearEndStr } from '../../utils/calcDatetime';

const [LIST_TAXBILLS, LIST_TAXBILLS_SUCCESS, LIST_TAXBILLS_FAILURE] =
  createRequestActionTypes('taxbill/LIST_TAXBILLS');
export const listTaxbills = createAction(
  LIST_TAXBILLS,
  (searchData) => searchData,
);
const listTaxbillsSaga = createRequestSaga(
  LIST_TAXBILLS,
  taxbillApi.getTaxbills,
);

const UNLOAD_TAXBILLS = 'taxbill/UNLOAD_TAXBILLS';
export const unloadTaxbills = createAction(UNLOAD_TAXBILLS);

const SET_TAXBILLS_FILTERS = 'taxbill/SET_TAXBILLS_FILTERS';
export const setTaxbillsFilters = createAction(
  SET_TAXBILLS_FILTERS,
  (filters) => filters,
);

const RESET_TAXBILLS_FILTERS = 'taxbill/RESET_TAXBILLS_FILTERS';
export const resetTaxbillsFilters = createAction(RESET_TAXBILLS_FILTERS);

export function* taxbillsSaga() {
  yield takeLatest(LIST_TAXBILLS, listTaxbillsSaga);
}

const initialState = {
  totalPrice: null,
  taxbills: null,
  defaultFilters: {
    searchOsTran: 'A',
    searchInvTyp: '매출', //매입,매출
    searchTyp: '', //월간조회(현재 사용안함)
    searchYn: 'A', //전체,발행완료,미완료(reqCompYn)
    searchKeyword: 'cstNm',
    searchWords: '',
    // 검색 기간 기본값은 비워두지 않고 오늘 기준 앞뒤 1년으로 둔다(비우면 "YYYY-MM-DD"
    // placeholder에 에러 테두리로 보이고 전체기간이 조회돼 목록이 과도하게 길어진다).
    searchStrtDt: recentOneYearStr,
    searchEndDt: recentOneYearEndStr,
  },
  error: null,
};

const taxbills = handleActions(
  {
    [LIST_TAXBILLS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      totalPrice: data?.totalPrice,
      taxbills: data.list.map((inv) => ({
        id: inv.invUuid,
        invUuid: inv.invUuid,
        prjUuid: inv.prjUuid,
        roUuid: inv.roUuid,
        billUuid: inv.billUuid,
        prjNo: inv.prjNo,
        invTyp: inv.invTyp,
        invTxt: inv.invTxt,
        cstNm: inv.cstNm,
        partnerNm: inv.partnerNm,
        invNo: inv.invNo,
        invYn: inv.invYn,
        invAmt: Number(inv.invAmt),
        invVat: Number(inv.invVat),
        invTot: Number(inv.invTot),
        reqPlanDt: inv.reqPlanDt,
        reqPlanYn: inv.reqPlanYn,
        reqPlanUsr: inv.reqPlanUsr,
        reqPlanUsrNm: inv.reqPlanUsrNm,
        reqPlanTxt: inv.reqPlanTxt,
        reqCompDt: inv.reqCompDt,
        reqCompYn: inv.reqCompYn,
        reqCompUsr: inv.reqCompUsr,
        reqCompUsrNm: inv.reqCompUsrNm,
        reqCompTxt: inv.reqCompTxt,
        procPlanDt: inv.procPlanDt,
        procPlanYn: inv.procPlanYn,
        procPlanUsrNm: inv.procPlanUsrNm,
        procCompDt: inv.procCompDt,
        procCompYn: inv.procCompYn,
        procTyp: inv.procTyp,
        rsltCompDt: inv.rsltCompDt,
        rsltCompYn: inv.rsltCompYn,
        salesUsrNm: inv.salesUsrNm,
        salesUsrUuid: inv.salesUsrUuid,
        crtUsr: inv.crtUsr,
        crtNm: inv.crtNm,
        crtGradeNm: inv.crtGradeNm,
        crtDptNm: inv.crtDptNm,
        crtDt: inv.crtDt,
        cngUsr: inv.cngUsr,
        cngNm: inv.cngNm,
        cngDt: inv.cngDt,
      })),
      error: null,
    }),
    [LIST_TAXBILLS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_TAXBILLS]: () => initialState,
    [RESET_TAXBILLS_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_TAXBILLS_FILTERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default taxbills;
